import { render, staticRenderFns } from "./MobileAppDemo.vue?vue&type=template&id=2a06636a&scoped=true"
import script from "./MobileAppDemo.vue?vue&type=script&lang=js"
export * from "./MobileAppDemo.vue?vue&type=script&lang=js"
import style0 from "./MobileAppDemo.vue?vue&type=style&index=0&id=2a06636a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06636a",
  null
  
)

export default component.exports